'use client';
import { useSyncExternalStore } from 'react';
import { BREAKPOINTS } from '../tokens/breakpoints.js';
const QUERY = `(max-width: ${BREAKPOINTS.md - 1}px)`;
function subscribe(callback) {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function')
        return () => { };
    const mql = window.matchMedia(QUERY);
    mql.addEventListener('change', callback);
    return () => mql.removeEventListener('change', callback);
}
function getSnapshot() {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function')
        return false;
    return window.matchMedia(QUERY).matches;
}
function getServerSnapshot() {
    return false;
}
/** `md` (768px) is THE canonical mobile↔desktop switch (CLAUDE_DESIGN.md §2.5) —
 * drives `<DataTable>`'s table→card-list re-flow. */
export function useIsMobile() {
    return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
